import React from "react";

/**
 * Official Hysteregistry logo — uses the brand-owner-uploaded PNG assets,
 * pre-cropped to remove transparent canvas padding so the full artwork
 * (heart + curved arms + gift boxes) renders at its true aspect ratio.
 *
 * Natural content ratio: 1.316 (wider than tall — curved arms extend outward
 * to gift boxes on either side of the heart).
 */
const ICON_COLOR = "/brand/pink_icon.png";
const ICON_WHITE = "/brand/white_icon.png";
const ICON_ASPECT = 1.316; // width / height

/**
 * `size` = height in pixels. Width is derived from the true icon aspect ratio
 * so the curved arms + gift boxes are never squashed into a square box.
 */
export function LogoMark({ size = 32, className = "", title = "Hysteregistry", variant = "color" }) {
  const src = variant === "white" ? ICON_WHITE : ICON_COLOR;
  const height = size;
  const width = Math.round(size * ICON_ASPECT);
  return (
    <img
      src={src}
      alt={title}
      width={width}
      height={height}
      className={className}
      style={{ width, height, objectFit: "contain", display: "block" }}
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );
}

/**
 * Horizontal lockup: icon + wordmark. Wordmark is rendered in Outfit
 * with the "registry" portion in accent purple — matches brand typography.
 */
export default function Logo({
  size = 36,
  showWordmark = true,
  variant = "color",
  className = "",
  wordmarkClass = "",
}) {
  const wordmarkInk = variant === "white" ? "text-white" : "text-ink";
  const wordmarkAccent = variant === "white" ? "text-white/80" : "text-accent2";

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} variant={variant} />
      {showWordmark && (
        <span className={`font-outfit font-semibold tracking-tight leading-none ${wordmarkInk} ${wordmarkClass}`}>
          Hyste<span className={`${wordmarkAccent} font-semibold`}>registry</span>
        </span>
      )}
    </span>
  );
}
